module.exports = __webpack_public_path__ + "img/10377@2x.88378ae7.png";